<div>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    *ngIf="router.url.includes('admin-dashboard') && isExpand"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <div *ngIf="!storageService.detectMob()">
    <div>
      <div class="row mt-4">
        <div class="col-md-12 col-lg-6">
          <ng-container
            [ngTemplateOutlet]="period === 'month' ? monthPeriodNavigation : weekPeriodNavigation"
          ></ng-container>
        </div>
        <div class="col-md-12 col-lg-6 text-right select-range-content">
          <div class="d-flex justify-content-md-center justify-content-lg-end">
            <mat-form-field appearance="outline" class="">
              <mat-label>Select Range</mat-label>
              <mat-select
                name="type"
                [(ngModel)]="type"
                (selectionChange)="setPeriodAndGetChartData($event.value)"
              >
                <mat-option
                  class="quicksand-bold-label select-range"
                  *ngFor="let period of types"
                  [value]="period"
                >
                  {{ period | titlecase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center" *ngIf="period === 'week'">
      <h5 class="quicksand-bold-label">
        {{ viewDate | calendarDate : calendarViewType + 'ViewTitle' : 'en' }}
      </h5>
    </div>

    <div
      echarts
      [options]="options"
      [merge]="mergeOptions"
      class="demo-chart"
    ></div>
  </div>

  <div *ngIf="storageService.detectMob()">
    <div class="col-12 text-right select-contain">
      <div>
        <mat-form-field appearance="outline" class="">
          <mat-label>Select Range</mat-label>
          <mat-select
            name="type"
            [(ngModel)]="type"
            (selectionChange)="setPeriodAndGetChartData($event.value)"
          >
            <mat-option
              class="quicksand-bold-label select-range"
              *ngFor="let period of types"
              [value]="period"
            >
              {{ period | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <ng-container
          [ngTemplateOutlet]="period === 'month' ? monthPeriodNavigation : weekPeriodNavigation"
        ></ng-container>
      </div>
      <div class="col-6">
        <div class="text-center" *ngIf="period === 'week'">
          <h5 class="quicksand-bold-label">
            {{ viewDate | calendarDate : calendarViewType + 'ViewTitle' : 'en' }}
          </h5>
        </div>
      </div>
    </div>

    <div
      echarts
      [options]="options"
      [merge]="mergeOptions"
      class="demo-chart"
    ></div>
  </div>
</div>

<!-- Month Period Navigation -->
<ng-template #monthPeriodNavigation>
  <div class="d-flex">
    <button
      mwlCalendarPreviousView
      [view]="calendarViewType"
      [(viewDate)]="viewDate"
      class="navigate-btn one"
      aria-label="Example icon button with a home icon"
      (click)="setValuesAndGetMonthsAssignments(false, 'previous')"
      [disabled]="isCalendarStart"
    >
      <mat-icon class="navigate-icon">navigate_before</mat-icon>
    </button>
    <button
      mwlCalendarNextView
      [view]="calendarViewType"
      [(viewDate)]="viewDate"
      class="navigate-btn two"
      aria-label="Example icon button with a home icon"
      (click)="setValuesAndGetMonthsAssignments(false, 'next')"
      [disabled]="isCalendarEnd"
    >
      <mat-icon class="navigate-icon">navigate_next</mat-icon>
    </button>
  </div>
</ng-template>

<!-- Week Period Navigation -->
<ng-template #weekPeriodNavigation>
  <div
    class="d-flex justify-content-md-center justify-content-lg-start mb-lg-2 mb-md-2"
  >
    <button
      mwlCalendarPreviousView
      [view]="calendarViewType"
      [(viewDate)]="viewDate"
      class="navigate-btn one"
      aria-label="Example icon button with a home icon"
      (click)="getData()"
      [disabled]="isCalendarStart"
    >
      <mat-icon class="navigate-icon">navigate_before</mat-icon>
    </button>
    <button
      mwlCalendarToday
      [(viewDate)]="viewDate"
      class="today-btn quicksand-bold-label"
      aria-label="Example icon button with a home icon"
      (click)="getData()"
    >
      Today
    </button>
    <button
      mwlCalendarNextView
      [view]="calendarViewType"
      [(viewDate)]="viewDate"
      class="navigate-btn two"
      aria-label="Example icon button with a home icon"
      (click)="getData()"
      [disabled]="isCalendarEnd"
    >
      <mat-icon class="navigate-icon">navigate_next</mat-icon>
    </button>
  </div>
</ng-template>
